export const DEFAULT_MICROSITE_BROWSER_TITLE = '半度云智能会务系统'

/** The public API applies membership rules; never fall back to activity/share titles. */
export function resolveMicrositeBrowserTitle (data) {
  return String(data?.browserTitle || data?.page?.meta?.browserTitle || '').trim() || DEFAULT_MICROSITE_BROWSER_TITLE
}
